import React from "react";
import { Link } from "react-router-dom";

import { Table } from "components/UI";

const buildingColumns = [
  {
    Header: "Floor #",
    accessor: "floor",
    width: 80
  },
  {
    Header: "Line",
    accessor: "line",
    width: 80
  }
];

const unitColumns = [
  {
    Header: "Unit",
    accessor: "unit",
    width: 80
  },
  {
    Header: "Room",
    accessor: "room",
    width: 150
  },
  {
    Header: "Radiator",
    accessor: "radiator",
    width: 80
  }
];

const BuildingAlertTable = ({ data, building, unit, remover }) => {
  const columns = [
    {
      id: "link",
      accessor: "link",
      width: 40,
      Cell: props => <Link to={`/${props.value}`}>link</Link>
    },
    {
      Header: "ID",
      accessor: "id",
      width: 50
    },
    {
      id: "date",
      Header: "Date",
      width: 170,
      accessor: row => {
        let date = new Date(row.timestamp);
        let month = date.getMonth() + 1
        return (
          month +
          "/" +
          date.getDate() +
          " " +
          date.toLocaleTimeString()
        );
      }
    },
    {
      Header: "Type",
      accessor: "type",
      width: 100
    },
    ...(building ? buildingColumns : []),
    ...(unit ? unitColumns : []),

    {
      Header: "Severity",
      accessor: "severity",
      width: 80
    },
    {
      Header: "Count",
      accessor: "count",
      width: 90
    },
    {
      columns: [
        {
          expander: true,
          Header: () => <span>Description</span>,
          accessor: "description",
          width: 100,
          Expander: ({ isExpanded, ...rest }) => (
            <div>
              {isExpanded ? <span>&#x2299;</span> : <span>&#x2295;</span>}
            </div>
          ),
          style: {
            cursor: "pointer",
            fontSize: 25,
            padding: "0",
            textAlign: "center",
            userSelect: "none"
          }
        }
      ]
    },
    {
      Header: "",
      id: "remover",
      accessor: row => row,
      width: 150,
      Cell: ({ value }) => (
        <button onClick={() => remover(value.id)}>Acknowledge</button>
      )
    },
    {
      accessor: "description",
      width: 0
    }
  ];

  return (
    <Table
      data={data}
      columns={columns}
      SubComponent={data => (
        <div style={{ padding: "10px" }}>
          <ul>
            {data.row.description
              .split(".\n")
              .map(s => (s !== "" ? <li>{s}</li> : <span />))}
          </ul>
        </div>
      )}
    />
  );
};

export default BuildingAlertTable;



// WEBPACK FOOTER //
// ./src/components/Alert/BuildingAlertTable.jsx